<template>
  <fragment>
    <config-style-injector :config="config" :root-selector="`.toggle-button-filter.${className}`"/>
    <button v-if="enabled" v-show="showMetroToggleButton" id='toggleButton' :class="`btn toggle-button-filter ${className} ${buttonClass}`" :toggle="featureConfig.value? 'on':'off'"
            v-bind="config.attrs" @click="toggle" @dblclick="handleDoubleClick"
            @click.middle="handleTripleClick">{{ buttonLabel }}
    </button>
  </fragment>
</template>

<script>
import featureMixin from "@/mixins/featureMixin";
import ConfigStyleInjector from "@/components/style-injector/ConfigStyleInjector.vue";
import {mapActions, mapGetters} from "vuex";
import {kebabCase} from "lodash";


export default {
  name: "ToggleButtonFilter",
  components: {ConfigStyleInjector},
  mixins: [featureMixin],
  methods: {
    ...mapActions('events', ['triggerEvent']),
    toggle() {
      this.featureConfig.value = !this.featureConfig.value;

      this.triggerEvent({
        event: `filter-toggle-event-${this.config.name}`,
        data: {selected: !!this.featureConfig.value, label: this.config.label}
      });
    },

    handleDoubleClick() {
      setTimeout(() => {
        this.featureConfig.value = !this.featureConfig.value;
      }, 200)
    }
  },
  computed: {

    ...mapGetters('config', ['branding']),
    ...mapGetters('filters', ['hasMadeInCanadaOrQuebecProducts']),

    className() {
      return kebabCase(this.config.name);
    },

    buttonLabel() {
        return this.config.label;
    },
    buttonClass() {
      return this.buttonLabel === 'ThunderBucks' ? 'thunderbucks-button' : '';
    },
    showMetroToggleButton() {
      if(this.config.name==='halal' || this.config.name==='beWell') return true;
      return ((this.config.name === 'madeInCanada' || this.config.name==='madeInQuebec') && this.hasMadeInCanadaOrQuebecProducts)
    }
  }
}
</script>

<style scope>
.toggle-button-filter.Points.thunderbucks-button {
  font-family: unset;
  font-size: 1em;
  color: red;
  padding: 0 28px;
  background: unset;
  background-color: white;
  background-image: url("/images/Thunderbucks-Button-container-new.svg");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

.toggle-button-filter.Points.thunderbucks-button[toggle='on'] {
  background-color: white;
  color: red;
}

[mode="mobile"] {
	.toggle-button-filter {
		flex-basis:47%;
	}
}
</style>
